import { styled } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export const SectionHeading = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
});

export const CssTabs = styled(Tabs)({
    minHeight: 48,
    marginTop: 16,
    borderBottom: '1px solid var(--divider)',
    '& .MuiTabs-indicator': {
        backgroundColor: 'var(--primary-main)',
    },
});

export const CssTab = styled(Tab)({
    fontFamily: 'Rubik, sans-serif',
    textTransform: 'none',
    padding: '12px 16px',
    minHeight: 48,
    fontSize: '0.875rem',
    letterSpacing: '0.25px',
    color: 'var(--text-secondary)',
    '&.Mui-selected': {
        color: 'var(--primary-main)',
    },
});

export const TabLabel = styled('span')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
});

export const Panel = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    paddingTop: 16,
});

export const FieldHeading = styled('div')({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    '& .MuiButton-root': {
        marginBlock: -8,
    },
});

export const CustomizeRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 12,
});

export const CtaRow = styled('div')({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
    },
});

export const Notices = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
});

export const StatusDot = styled('span')({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'var(--error-main)',
    display: 'inline-block',
    flexShrink: 0,
});

export const CustomizedDot = styled(StatusDot)({
    backgroundColor: 'var(--primary-main)',
});
